import DropdownIndicator from './DropdownIndicator';

export default DropdownIndicator;
